import CategoryUpsertModal from 'modals/CategoryUpsertModal/CategoryUpsertModal'

export default CategoryUpsertModal
